export function toFixed(num: number, fixed: number) {
  if (num === 0) {
    return '0.00'
  }
  const roundedNum = num.toFixed(fixed)
  const [integer, decimals] = roundedNum.split('.')
  return `${integer}.${(decimals || '').padEnd(2, '0')}`
}
